import Utils from "../../utils/utils"

export class PremiumColors {
    public primaryButtonColor: string = ""
    public secondaryButtonColor: string = ""
    public mainColor: string = ""

    constructor(colors) {
        Object.keys(colors).map((key) => {
            const property = Utils.convertToCamelcase(key)
            this[property] = colors[key]
        })
    }
}
